//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import step from '@/components/Step'
import top from '@/components/top'
import { dataMixins } from '@/mixins'
import checkboxConfirm from '@/components/checkbox-confirm'
import next from '@/components/utake-next-fixed'
import { getCache } from '@/utils/storage'
import date from '@/utils/date'
import { config, api } from '@/service'
let _setTimeout;
export default {
	mixins: [dataMixins],
	data() {
		return {
			isSignature: false, // 是否允许应用
			isPay: false, // 是否允许支付标示
			info: {},
			db: {},
			terms: {},
			agree: {
				first: true,
				second: true,
				third: false
			},
			dialog: {
				show: false,
				content: '',
				title: '',
				img: false
			},
			form: {
				way: ''
			},
			payList: [],
			hidePayList: false,
			billType: ''
		}
	},
	mounted() {
		// 获取协议内容
		this.newQueryByCode()
		// 初始化信息
		this.init()
	},
	filters: {
		address(e) {
			return `${e.area} ${e.district} ${e.streetName || ''} ${e.estateInput || ''} ${e.buildingInput || ''} ${e.blockInput ? `${e.blockInput}${e.blockBox}` : ''} ${e.floorInput ? `${e.floorInput}${e.floorBox}` : ''} ${e.flatInput ? `${e.flatInput}${e.flatBox}` : ''}`
		}
	},
	methods: {
		date,
		backMethod() {
			this.modifyFn(0)
		},
		modifyFn(index) {
			let params = this.$route.query
			this.$router.replace({
				name: 'UmallInformationRegister',
				query: { ...this.$route.query,
					modifyPosition: index
				}
			})
		},
		getContract(url) {
			let _data = {
				content: `${config.baseUrl}${api.getContract}?orderId=${this.$route.query.id}&random=${Math.random()}`,
				name: '合約'
			}
			if(url) _data.content = `${_data.content}&signaturePicPath=${url}&random=${Math.random()}`
			this.terms.contract = _data
			this.terms = Object.assign({}, this.terms)
		},
		getPcPackage(id) {
			this.$http('businessInfo/queryPcBusiness', {
				businessId: this.db.businessPlanId,
				marketSceneId: 1,
				businessType: 1,
				registerTypeId: this.db.registerType,
				orgId: this.$client.orgid,
				shopId: this.$client.shopid,
				userId: this.$client.userid,
			}).then(res => {
				if(res.returnCode == 1000) this.info = res.dataInfo
			})
		},
		async init() {
			// 同步数据库数据
			await this.getDBData()
			// 获取套餐信息
			await this.getPcPackage(this.db.businessPlanId)
			// 获取支付方式
			await this.getPayList()
			// 获取合約
			this.getContract()
		},
		getDBData() {
			return this.$http('pcOrderInfo/queryOrderInfo', {
				id: this.$route.query.newOrderId ? this.$route.query.newOrderId : this.$route.query.id,
				orgId: this.$client.orgid,
				shopId: this.$client.shopid,
				userId: this.$client.userid,
			}).then(res => {
				if(res.returnCode == 1000) {
					this.db = res.dataInfo;
					if(res.dataInfo && res.dataInfo.billType) {
						this.billType = res.dataInfo.billType
					}

				}
			})
		},
		getPayList() {
			return this.$http('payTypeList', {
				scene: 852, //852 pC
				registerType: this.db.registerType,
				purchaseType: this.$route.query.packageType,
				orgId: this.$client.orgid,
				shopId: this.$client.shopid,
				userId: this.$client.userid,
			}).then(res => {
				if(res.returnCode == 1000) {
					// 删除现金支付的方式  以及 payment on bill
					res.dataInfo.payTypes.some((e, i) => {
						if(e.name === '现金支付') res.dataInfo.payTypes.splice(i, 1)
					})
					// 处理二维码支付的方式
					res.dataInfo.payTypes.forEach(e => {
						if(e.identifying != 1) e.type = `${e.type}_${e.identifying}`
					})
					if(this.billType == 2 || this.billType == 3) { //优先处理162優先級提前 payment on bill
						this.payList = res.dataInfo.payTypes.filter(
							item => item && item.type == 162
						);
					} else {
						// 处理若总计为0则仅允许0元支付，否则去掉0元支付
						let len = res.dataInfo.payTypes.length - 1,
							totalFee = this.db.paymentDetail.totalFee
						while(len >= 0) {
							if(totalFee == 0 && res.dataInfo.payTypes[len].type != 161) res.dataInfo.payTypes.splice(len, 1)
							else if(totalFee != 0 && res.dataInfo.payTypes[len].type == 161) res.dataInfo.payTypes.splice(len, 1)
							len--;
						}
						if(res.dataInfo.payTypes.length === 1 && res.dataInfo.payTypes[0].type == 161) this.hidePayList = true
						this.payList = res.dataInfo.payTypes;
					}
					//						// 处理若总计为0则仅允许0元支付，否则去掉0元支付
					//						let len = res.dataInfo.payTypes.length - 1,
					//							totalFee = this.db.paymentDetail.totalFee
					//						while(len >= 0) {
					//							if(totalFee == 0 && res.dataInfo.payTypes[len].type != 161) res.dataInfo.payTypes.splice(len, 1)
					//							else if(totalFee != 0 && res.dataInfo.payTypes[len].type == 161) res.dataInfo.payTypes.splice(len, 1)
					//							len--;
					//						}
					//						if(res.dataInfo.payTypes.length === 1 && res.dataInfo.payTypes[0].type == 161) this.hidePayList = true
					//						this.payList = res.dataInfo.payTypes;
					console.log(this.payList, '320')
					// 默認選中一種付款方式
					this.handleRadioClick(this.payList[0])
				}
			})
		},
		async dialogFn({
			show,
			id,
			img = false,
			type
		}) {
			if(id == 'contract') {
				//點擊了合約查看
				await this.saveSign()
			}
			if(type === 'sure' && this.dialog.title === '合約') {
				this.agree.third = true
				this.$refs['checkboxConfirm-third'].setCheck(true)
			}
			this.dialog.show = show
			if(id) {
				this.dialog.content = this.terms[id].content
				this.dialog.title = this.terms[id].name
			}
			this.dialog.img = img
		},
		async handleNext() {
			this.saveSign()
			// 限制签名才可以繼續
			if(this.$refs.signature.isEmpty()) {
				window.scroll(0, this.$refs['signature-container'].offsetTop)
				return this.$message({
					customClass: this.$device,
					showClose: true,
					message: '請簽名並應用後重試',
					type: 'warning'
				});
			}
			// 必須勾選所有勾選項才可以提交            
			if(!this.agree.first || !this.agree.second || !this.agree.third) return this.$message({
				customClass: this.$device,
				showClose: true,
				message: '請閱讀並勾選協議內容和合約內容',
				type: 'warning'
			});
			let skuId;
			this.info.contractList.some(e => {
				if(e.months == this.db.contractPeriod) return skuId = e.skuId
			})
			let {
				id,
				packageType
			} = this.$route.query, {
				phoneNo,
				customerId,
				customerInfo,
				transactType
			} = this.db
			// 下订单  
			let params = {
				payType: this.form.way.split('_')[0],
				purchaseType: packageType,
				payPlatform: 3,
				businessPlan: this.info.businessName,
				paymentType: 2,
				businessPhone: phoneNo,
				orderGenerateSource: 1, //852 eshop 官网
				userInfo: {
					id: this.$client.userid,
					shopId: this.$client.shopid,
					orgId: this.$client.orgid
					// shopCode: 'PT02'
				},
				productInfo: [{
					skuId: skuId,
					id: this.info.id,
					productQty: 1
				}],
				deliveryInfo: {
					logisticType: transactType,
					takeDistrict: customerInfo.addressInfoVo.district,
					takeDepartName: customerInfo.addressInfoVo.detailedAddress
				},
				customerInfo: {
					userId: customerId,
					buyerName: `${customerInfo.lastName} ${customerInfo.firstName}`,
					buyerPhone: customerInfo.contactNumber,
					buyerEmail: customerInfo.email,
					buyerLastName: customerInfo.lastName,
					buyerFirstName: customerInfo.firstName
				},
				origin: 3,
				boId: id,
				frontUrl: '#/resultUmall/info',
				offerIds: null
			}
			let shipName = this.db.customerInfo.firstName + ' ' + this.db.customerInfo.lastName
			if(transactType == "6" || transactType == "4") { //順風自取櫃
				let data = this.db
				params.deliveryInfo.takeDistrict = data.takeRegion
				params.deliveryInfo.takeDepartName = data.takeOrg
				let shippingAddress = {
					//收貨地址
					province: "香港",
					city: data.deliverAddrInfoVo ? data.deliverAddrInfoVo.area : '',
					district: data ? data.takeRegion : '',
					detailAddress: data.takeRegion + ' ' + data.takeOrg,
					shipName: shipName,
					shipPhone: data.customerInfo.contactNumber
				};
				params.deliveryAddress = shippingAddress
			}
			if(transactType == "2") {
				let data = this.db
				let shippingAddress = {
					//收貨地址
					province: "香港",
					city: data.deliverAddrInfoVo ? data.deliverAddrInfoVo.area : '',
					district: data ? data.deliverAddrInfoVo.district : '',
					detailAddress: Object.values(data.deliverAddrInfoVo)
						.toString()
						.replace(/,/g, " "),
					shipName: shipName,
					shipPhone: data.customerInfo.contactNumber
				};
				params.deliveryAddress = shippingAddress
			}
			const res = await this.$http('order/create', params)
			//          if(res && res.returnCode == 1000) this.pay(res.dataInfo, 1)
			if(res && res.returnCode == 1000) this.pay(res.dataInfo, 1, params)
		},
		//      async pay(id, count) {
		//          this.$store.commit("SET_LOADING", true)
		//          if(count > (process.env.NODE_ENV === 'production' ? 30 : 50)) return            
		//          let _url = `${window.location.href.split('/#/')[0]}/#/`,
		//              res = await this.$http('order/pay', {
		//              frontUrl: window.location.href,
		//              lang: 'X',
		//              successURL: `${_url}result/success`,
		//              paymentType: 2,
		//              failURL: `${_url}result/fail`,
		//              cancelURL: window.location.href,
		//              origin: 3,
		//              payPlatform: 3,
		//              payType: this.form.way.split('_')[0],
		//              mainOrderId: id
		//          }, 'post', {}, false, false)
		//          if(res && res.returnCode == 2009) {
		//              clearTimeout(_setTimeout)
		//              _setTimeout = setTimeout(()=>{
		//                  this.pay(id, count + 1)
		//              }, process.env.NODE_ENV === 'production' ? 1000 : 1500)
		//          }else if(res && res.returnCode == 1000){
		//              this.$store.commit("SET_LOADING", false)
		//              switch(this.form.way) {
		//                  case '161': // 0元支付
		//                      this.confirmCashPay(id)
		//                  break;
		//                  case '14': // 支付寶
		//                      this.submitForm(res.dataInfo)
		//                  break;
		//                  case '23': // 銀行卡支付
		//                      this.submitForm(res.dataInfo)
		//                  break;
		//              }                
		//          }else this.$store.commit("SET_LOADING", false)            
		//      },
		async pay(id, count, params) {
			this.$store.commit("SET_LOADING", true)
			if(count > (process.env.NODE_ENV === 'production' ? 30 : 50)) {
				this.$store.commit("SET_LOADING", false)
				return
			};
			let payPlatform;
			let parms = {};
			if(this.form.identifying == 2) { //如果是二维码支付
				if(this.form.way.split('_')[0] == 15 || this.form.way.split('_')[0] == 160) { //两种特定情况，需要单租处理
					payPlatform = 5;
				} else {
					payPlatform = 3;
				};
				parms = { //入参
					purchaseType: params.purchaseType,
					frontUrl: '#/resultUmall/success',
					lang: 'X',
					successURL: '#/resultUmall/success',
					paymentType: 2,
					failURL: '#/resultUmall/fail',
					cancelURL: '#/resultUmall/fail',
					origin: 3,
					payPlatform: payPlatform, ///二維碼支付==2，給後台傳2
					payType: this.form.identifying == 2 ? this.form.way.split('_')[0] : this.form.way,
					mainOrderId: id,
					orgId: this.$client.orgid,
					shopId: this.$client.shopid,
					userId: this.$client.userid,
				}
			} else { //非二维码支付
				const URL = `${location.origin}${location.pathname}${location.search}`;
				const URLTWO = decodeURIComponent(URL);
				console.log(URLTWO, '464--------')
				parms = { //入参
					purchaseType: params.purchaseType,
					frontUrl: URLTWO + '#/resultUmall/success',
					lang: 'X',
					successURL: URLTWO + '#/resultUmall/success',
					paymentType: 2,
					failURL: URLTWO + '#/resultUmall/fail',
					cancelURL: URLTWO + '#/resultUmall/fail',
					origin: 3,
					payPlatform: 3, ///二維碼支付==2，給後台傳2
					payType: this.form.identifying == 2 ? this.form.way.split('_')[0] : this.form.way,
					mainOrderId: id,
					orgId: this.$client.orgid,
					shopId: this.$client.shopid,
					userId: this.$client.userid,
				}
			};
			const res = await this.$http('order/pay', parms, 'post', {}, false, false)
			//				let _url = `${window.location.href.split('/#/')[0]}/#/`,
			//
			//					res = await this.$http('order/pay', {
			//						purchaseType: params.purchaseType,
			//						frontUrl: '#/result/success',
			//						lang: 'X',
			//						successURL: '#/result/success',
			//						paymentType: 2,
			//						failURL: '#/result/fail',
			//						cancelURL: '#/result/fail',
			//						origin: 3,
			//						payPlatform: this.form.identifying == 2 ? payPlatform : 3, ///二維碼支付==2，給後台傳2
			//						payType: this.form.identifying == 2 ? this.form.way.split('_')[0] : this.form.way,
			//						mainOrderId: id
			//					}, 'post', {}, false, false)
			if(res && res.returnCode == 2009) {
				clearTimeout(_setTimeout)
				_setTimeout = setTimeout(() => {
					this.pay(id, count + 1, params)
				}, process.env.NODE_ENV === 'production' ? 1000 : 1500)
			} else if(res && res.returnCode == 1000) {
				//					debugger
				this.$store.commit("SET_LOADING", false)
				let isQrCode = this.form.way.split('_').length > 1
				let payType = this.form.way
				console.log(payType, '---462')
				if(payType == 0 ||
					payType == 159 ||
					payType == 161 ||
					payType == 162 ||
					payType == 164 ||
					payType == 165 ||
					payType == 166 ||
					payType == 167) {
					this.confirmCashPay(id)
				} else if(isQrCode) {
					//二维码支付
					// 二维码支付
					let qrcodeData = {
						...params,
						search: `${location.search}`,
						hash: params.frontUrl,
						mainOrderId: id
					};
					this.$session.set("payData", qrcodeData); // 二维码支付把支付信息存在session中
					let list = this.form.way.split('_')
					let way = list[0]
					let payData = Object.assign(res.dataInfo, {
						'mainOrderId': id
					});
					this.$store.commit("setPayCommom", payData);
					if(way == 14) {
						//舊的二維碼支付方式
						this.$router.push({
							name: 'OldQrCodePay',
							query: {
								amount: payData.paymentRequest.Amount,
							}
						})
					} else {
						this.$router.push({ //新加的支付宝二维码页面
							name: 'NewQrCodePay',
							query: {
								amount: payData.paymentRequest.Amount,
								payType: payType
							}
						});
						//							this.submitQrCode(payData, payType)
					}
				} else {
					this.submitForm(res.dataInfo)
				}
				// switch(this.form.way) {
				//     case '161': // 0元支付
				//         this.confirmCashPay(id)
				//     break;
				//     case '14': // 支付寶
				//         this.submitForm(res.dataInfo)
				//     break;
				//     case '23': // 銀行卡支付
				//         this.submitForm(res.dataInfo)
				//     break;
				// }                
			} else this.$store.commit("SET_LOADING", false)
		},
		submitForm(params) {
			let {
				paymentRequest,
				paymentUrl
			} = params,
			str = '',
				data = Object.assign({}, paymentRequest)
			for(let value of Object.keys(data)) str += `<input type="hidden" name="${value}" value="${data[value]}" />`
			// 添加submit按钮
			str += `<input type='submit' />`
			let createPayFrom = this.$refs['pay-form']
			createPayFrom.method = 'post'
			createPayFrom.action = paymentUrl
			createPayFrom.innerHTML = str
			createPayFrom.submit()
		},
		//			submitQrCode(params, payType) {
		//				debugger
		//				// 二维码支付
		//				//				this.$store.commit("setPayCommom", params);
		//				this.$router.push({ //新加的支付宝二维码页面
		//					name: 'NewQrCodePay',
		//					query: {
		//						amount: params.paymentRequest.Amount,
		//						payType: payType
		//					}
		//				});
		//			},
		confirmCashPay(id) {
			return this.$http('order/confirmCashPay', {
				orderId: id,
				orgId: this.$client.orgid,
				shopId: this.$client.shopid,
				userId: this.$client.userid,
			}).then(res => {
				if(res.returnCode == 1000) this.$router.replace({
					path: '/resultUmall/info',
					query: {
						orderId: id
					}
				})
			})
		},
		newQueryByCode() {
			this.$http('newQueryByCode', {
				code: "General_conditions",
				isOpen: 1,
				orgId: this.$client.orgid,
				shopId: this.$client.shopid,
				userId: this.$client.userid,
			}).then(res => {
				if(res.returnCode == '1000') {
					res.dataInfo.forEach(element => {
						this.terms[element.id] = {
							content: element.content,
							name: element.name
						}
					})
				}
			})
		},
		sumbitSignaturePic(url) {
			return this.$http('sumbitSignaturePic', {
				id: this.$route.query.id,
				signaturePicPath: url,
				orgId: this.$client.orgid,
				shopId: this.$client.shopid,
				userId: this.$client.userid,
			})
		},
		save() {
			if(this.$refs.signature.isEmpty()) {
				return
				// return this.$message({
				// 	customClass: this.$device,
				// 	message: '簽名內容不能為空',
				// 	type: 'warning'
				// })
			}

			function convertBase64UrlToBlob(urlData) {
				const bytes = window.atob(urlData.split(',')[1]) // 去掉url的头，并转换为byte    
				// 处理异常,将ascii码小于0的转换为大于0   
				const ab = new ArrayBuffer(bytes.length)
				const ia = new Uint8Array(ab)
				for(let i = 0; i < bytes.length; i++) {
					ia[i] = bytes.charCodeAt(i);
				}
				return new Blob([ab], {
					type: 'image/png'
				})
			}

			let base64 = this.$refs.signature.save(),
				_img = convertBase64UrlToBlob(base64),
				formdata = new FormData()
			formdata.append('fileData', _img, `file_${new Date().getTime()}.png`)
			return this.$http('upload', formdata, 'post', {
				"Content-Type": "multipart/form-data"
			})
			// .then(res => {
			// 	// 签名上传成功后，处理上传的签名
			// 	if(res.returnCode == 1000) {

			// 	} 
			// })
		},
		signaTureClear() {
			this.agree.third = false
			this.$refs['checkboxConfirm-third'].setCheck(false)
			this.isPay = false
			this.isSignature = false
			this.getContract()
			this.$refs.signature.clear()
		},
		handleRadioClick(params) {
			this.form.way = params.type;
			this.form.identifying = params.identifying * 1
			this.form = Object.assign({}, this.form);
			console.log(this.form, '625')
			console.log(params, '626')
		},
		//保存簽名
		async saveSign() {
			if(!this.isSignature) {
				return
			}
			const saveRes = await this.save()
			console.log(saveRes)
			if(saveRes.returnCode == 1000) {
				const signRes = await this.sumbitSignaturePic(saveRes.dataInfo.url)
				if(signRes.returnCode == 1000) {
					this.getContract(saveRes.dataInfo.url)
					this.isPay = true
					this.isSignature = false
					this.$message({
						customClass: this.$device,
						message: '簽名應用成功',
						type: 'success'
					})
				}
			}
		},
		//簽名check回調
		signCheck(result) {
			if(result) {
				this.saveSign()
			}
		},
		signStart() {
			this.isSignature = true
			if(this.agree.third) {
				this.isPay = true
			}
		}
	},
	computed: {
		// showShipDetail() {
		//     let data = this.db
		//     if (data.transactType == 4 || data.transactType == 6) {
		//         return true
		//     }
		//     return false
		// },
		simDetail() {
			let data = this.db
			if(data.transactType == '5') {
				return 'eSIM卡'
			}
			return '實體SIM卡'
		},
		shipAddress() {
			let data = this.db
			return data.takeRegion + ' ' + data.takeOrg
		},
		markShipAddress() {
			let data = this.db
			if(!data.deliverAddrInfoVo) {
				return null
			}
			if(!data.deliverAddrInfoVo.detailedAddress) {
				return null
			}
			return data.takeRegion + ' ' + data.deliverAddrInfoVo.detailedAddress
		}
	},
	components: {
		step,
		checkboxConfirm,
		next,
		top
	}
}
